// src/hooks/cities/useCreateCity.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createCity } from "../../api/apiCities";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useCreateCity = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createCityMutate, isPending } = useMutation({
        mutationFn: createCity,
        onSuccess: (res) => {
            const message = res?.message || "City created successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
            navigate("/cities");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to create city");
        },
    });

    return { createCityMutate, isPending };
};

export default useCreateCity;